<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoUsuario.idUsuario" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoUsuario.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPerfil" name="idPerfil" v-model="datoUsuario.idPerfil">
                      <option v-for="perfil in perfils" :value="perfil.idPerfil" :key="perfil.idPerfil">
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoUsuario.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="clave" class="form-label">Clave</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="clave" name="clave" v-model="datoUsuario.clave" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoUsuario.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoUsuario.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarUsuario" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditUsuario" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdSuscripcion</th>
          <th scope="col">IdPlan</th>
          <th scope="col">IdUsuario</th>
          <th scope="col">IdFormaPago</th>
          <th scope="col">Número</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">Estado</th>
          <th scope="col">FormaPagoNombre</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">PlanNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="suscripcion in datosPaginados" :key="suscripcion.idSuscripcion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(suscripcion.idSuscripcion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(suscripcion.idSuscripcion)" title="Editar">edit_square</i></td>
          <td>{{suscripcion.idSuscripcion}}</td>
          <td>{{suscripcion.idPlan}}</td>
          <td>{{suscripcion.idUsuario}}</td>
          <td>{{suscripcion.idFormaPago}}</td>
          <td>{{suscripcion.numero}}</td>
          <td>{{getFormattedDate(suscripcion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(suscripcion.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(suscripcion.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{suscripcion.estado}}</td>
          <td>{{suscripcion.formaPagoNombre}}</td>
          <td>{{suscripcion.usuarioNombre}}</td>
          <td>{{suscripcion.planNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteUsuario(suscripcion.idSuscripcion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idSuscripcion" class="form-label">IdSuscripcion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSuscripcion" name="idSuscripcion" v-model="datoSuscripcion.idSuscripcion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPlan" class="form-label"> Plan</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPlan" name="idPlan" v-model="datoSuscripcion.idPlan">
                      <option v-for="plan in plans" :value="plan.idPlan" :key="plan.idPlan">
                        {{ plan.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoSuscripcion.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idFormaPago" class="form-label"> Forma Pago</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFormaPago" name="idFormaPago" v-model="datoSuscripcion.idFormaPago">
                      <option v-for="formaPago in formaPagos" :value="formaPago.idFormaPago" :key="formaPago.idFormaPago">
                        {{ formaPago.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numero" class="form-label">Numero</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numero" name="numero" v-model="datoSuscripcion.numero" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoSuscripcion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoSuscripcion.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoSuscripcion.fechaHasta" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarSuscripcion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSuscripcion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      usuarios : [],
      datoUsuario : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idUsuario: '',
      perfils : [],
// Variables master
// Variables details
      suscripcions : [],
      datoSuscripcion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      plans : [],
      formaPagos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idUsuario = this.$route.params.p_idusuario
    this.abrirEditar(this.p_idUsuario)
    this.getDataPagina(this.paginaActual)
    this.fetchPerfils()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idPerfil'
        ,'nombre'
        ,'clave'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPerfil'
        ,'nombre'
        ,'clave'
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarUsuario(){
      if(this.validarForm() === 1){
        try {
          this.datoUsuario.idUsuario = window.sessionStorage.getItem("idUsuario");
          this.datoUsuario.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditUsuario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoUsuario={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idUsuario){
      this.modalWindow = true
      if(idUsuario != null){    
           api.get('/vwusuarios/'+idUsuario).then(resp=>{
          this.datoUsuario = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarUsuario(){
      this.$router.push('/Usuario')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.suscripcions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwsuscripcions/nombre/'+this.nombreBusqueda).then(response=>{
          this.suscripcions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.suscripcions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwsuscripcions').then(response=>{
      this.suscripcions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.suscripcions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idPerfil'
        ,'nombre'
        ,'clave'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPerfil'
        ,'nombre'
        ,'clave'
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarSuscripcion(){
      if(this.validarForm() === 1){
        try {
          this.datoSuscripcion.idUsuario = this.datoUsuario.idUsuario;
          await api.post('/suscripcions', this.datoSuscripcion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Suscripcion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSuscripcion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/suscripcions', this.datoSuscripcion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Suscripcion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoSuscripcion={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idSuscripcion){
      this.modalWindow = true
      if(idSuscripcion != null){    
           api.get('/vwsuscripcions/'+idSuscripcion).then(resp=>{
          this.datoSuscripcion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idSuscripcion){
      this.modalWindow = true
      if(idSuscripcion != null){
        this.$router.push('/suscripcionmd/'+idSuscripcion)
      }
    },
    async deleteSuscripcion (idSuscripcion) {
      try{
        await api.delete('/suscripcions/'+idSuscripcion)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPerfils() {
      fetch('http://localhost:8080/api/v1/perfils')
        .then(response => response.json())
        .then(data => {
          this.perfils = data;
        })
        .catch(error => {
          console.error('Error fetching perfils:', error);
        });
    },
    fetchPlans() {
      fetch('http://localhost:8080/api/v1/plans')
        .then(response => response.json())
        .then(data => {
          this.plans = data;
        })
        .catch(error => {
          console.error('Error fetching plans:', error);
        });
    },
    fetchFormaPagos() {
      fetch('http://localhost:8080/api/v1/formapagos')
        .then(response => response.json())
        .then(data => {
          this.formaPagos = data;
        })
        .catch(error => {
          console.error('Error fetching formaPagos:', error);
        });
    },
  },
}
</script>
